import { useEffect, useState } from "react";
import { _LoanLine } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Alert } from "../../../../../../modules/theme/Component/Alert";
import { Modal } from "../../../../../../modules/theme/Component/Modal";
import { _BusinessProcess, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { MASK_BOOLEAN, MASK_MONEY } from "../../../../../../modules/theme/Component/BasicTable";
import { useNavigate } from "react-router-dom";
import { PrintJson } from "../../../../../../modules/theme/Component/PrintJson";
import { BasicButton } from "../../../../../../modules/theme/Component/BasicButton";
import { ObjectDinamicViewer } from "../../../../../../modules/contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";

export const CreditsLoans = () => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_LoanLine);
    const [rules, setRules] = useState<any[]>([]);
    const [creditOpen, setCreditOpen] = useState<any>({});
    const [validatedCredits, setValidatedCredits] = useState<any[]>([]);
    const _bProcess = useDataBean(_BusinessProcess);
    const navigate = useNavigate();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalInfo, setModalInfo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        getCredit();
        getCreditValidation();
    }, []);

    const getCredit = () => {
        const apertura = _single.getSessionItem("OpenCredit") ? JSON.parse(_single.getSessionItem("OpenCredit")) : {};
        const creditos = apertura.LoanList;
        const reglas = apertura.JSONProps ? JSON.parse(apertura.JSONProps) : [];
        setLista(creditos);
        setRules(reglas);
        setCreditOpen(apertura);
    };

    const setAndOpen = (line: any, _CreditOpening?: number, _CreditOpeningName?: string) => {
        instance.getLoanLine(line.IDLoanLine).then(
            (resp) => {
                setBean({ ...resp, IDCreditOpening: _CreditOpening, CreditOpenName: _CreditOpeningName });
                setModal({ ...modal, view: true, name: `Solicitar crédito de ${resp.Name}` });
            }
        ).catch(
            err => (toast.error("No se pudo cargar la linea de credito"))
        )
    };

    const setAndOpenInfo = (line: any) => {
        setBean(line);
        setModalInfo({ ...modalInfo, view: true, name: `Información de crédito de ${line.Name}` });
    };

    const startProcess = () => {

        console.log(bean.IDLoanLine)

        if (_single.getAffiliate().IDCajaNominadora) {
            const payload = JSON.stringify({ ...bean, IDAccount: _single.getAccountID() });
            _bProcess.instance.requestBusinessProcess(
                _single.getAccountID(),
                `Se solicita crédito ${bean.Name}`,
                "SOLCREDITO",
                "IDLoanLine",
                bean.IDLoanLine,
                payload,
                ""
            ).then((resp) => {
                navigate("/portal/home/requests");
                toast.success(`Se ha iniciado el proceso con IDProcedureImp ${resp.AlphaCode}`);
                setModal({ ...modal, view: false });
            }).catch(() => toast.error("No se ha podido iniciar el proceso"));
        } else {
            toast.error("No se puede iniciar un trámite sin una Caja Nominadora");
        }
    };

    const eligibilityMessage = () => {
        const filters = rules ?? [];
        const affiliate = _single.getAffiliate();
        const messages = [];

        const propertyMap = {
            "TIPGENERO": "IDGenero",
            "TIPESTADO": "IDEstadoCivil",
            "TIPPERSONAGRADE": "TypeAccount",
            "LISTCIVIL": "IDGradoPersona",
            "GRADOSPOL": "IDGradoPersona",
            "TIPOOCU": "Ocupacion",
            "CiudadResidenciaIDLn": "CiudadResidenciaIDLn",
            "Number": "EdadCalculada"
        };

        const calculateAge = (birthDateStr) => {
            if (!birthDateStr) return NaN;
            const birthDate = new Date(birthDateStr);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        };

        filters.forEach(({ Prop, Operator, Value }) => {
            const affiliatePropName = propertyMap[Prop.PropertyValue];
            let userValue = affiliatePropName === "EdadCalculada"
                ? calculateAge(affiliate.FechaNacimiento)
                : affiliate[affiliatePropName];

            const userNumeric = parseFloat(userValue);
            const valueNumeric = parseFloat(Value);

            let isValid = true;

            switch (Operator) {
                case "=": isValid = userValue == Value; break;
                case "!=": isValid = userValue != Value; break;
                case ">": isValid = !isNaN(userNumeric) && userNumeric > valueNumeric; break;
                case "<": isValid = !isNaN(userNumeric) && userNumeric < valueNumeric; break;
                default: break;
            }

            if (!isValid) {
                messages.push(`${Prop.Description}: No cumple`);
            }
        });

        const isEligible = messages.length === 0;

        console.log("📄 Reglas no cumplidas:", messages);

        return { isEligible, messages };
    };

    const { isEligible, messages } = eligibilityMessage();

    const getCreditValidation = () => {
        instance.getLoanLinesByAffiliate(_single.getAffiliate().IDCreditAffiliate).then((data: any) => {
            // Asumiendo que 'data' es la lista de objetos validados
            setValidatedCredits(data);
        }).catch((error: any) => {
            console.log(error);
        });
    };

    const head = [
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Destino del Credito', property: 'LoanDestinationName', visible: true },
        { title: 'Porcentaje de Cuota', property: 'CurrentPercentInterest', visible: true },
        { title: 'Porcentaje de Cuota expirada', property: 'ExpiredPercentInterest', visible: true },
        { title: 'Rangos de Cuotas Disponibles', property: 'QuotaRange', visible: true },
        { title: 'Requiere Codeudor', property: 'RequiresCodebtor', visible: true, mask: MASK_BOOLEAN },
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-3">
                        <BasicButton eventClick={() => { navigate(`/portal/home/credit-lines`) }} icon="ri-arrow-left-line" children={`Volver`} />
                    </div>
                    <div className="col-9">
                        <h3>Líneas de crédito disponibles de {creditOpen.Name}</h3>
                        <h4>{creditOpen.Description}</h4>
                    </div>
                </div>
            </div>

            {!isEligible && (
                <div className="col-md-12 text-center mt-2 mb-4">
                    <Alert clase="danger" children="No cumples con los requisitos para solicitar el Credito" />
                </div>
            )}

            {(() => {
                const filteredCredits = lista.filter((item: any) =>
                    validatedCredits.some(
                        (validItem: any) =>
                            validItem.DataBeanProperties.IDLoanLine == item.DataBeanProperties.IDLoanLine
                    )
                );

                console.log(validatedCredits)
                return filteredCredits.length === 0 ? (
                    <div className="col-md-12 text-center">
                        <Alert clase="info" children="No hay líneas de crédito disponibles" />
                    </div>
                ) : (
                    filteredCredits.map((item: any, index: number) => {
                        const credito = item.DataBeanProperties;
                        return (
                            <div className="col-md-6" key={index}>
                                <div className="card">
                                    <div className="card-body p-0">
                                        <div className="alert alert-info border-0 rounded-top rounded-0 m-0 d-flex align-items-center" role="alert">
                                            <div className="flex-grow-1 text-truncate">
                                                <b>{credito.Name}</b>
                                            </div>
                                            <div className="flex-shrink-0">
                                                <a className="text-reset text-decoration-underline pointer" onClick={() => { setAndOpenInfo(credito) }}><b>Más Información</b></a>
                                            </div>
                                        </div>

                                        <div className="row align-items-end">
                                            <div className="col-sm-12">
                                                <div className="p-3">
                                                    <p dangerouslySetInnerHTML={{ __html: credito.Description }}></p>
                                                    <div className="mt-3">
                                                        <a
                                                            onClick={() => isEligible && setAndOpen(credito, creditOpen.IDCreditOpening, creditOpen.Name)}
                                                            className={`btn btn-success ${!isEligible ? "disabled" : ""}`}
                                                        >
                                                            ¡Solicitar Ya!
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="px-3">
                                                    <img src="assets/images/user-illustarator-2.png" className="img-fluid" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                );
            })()}

            <div className="col-md-12">
                <Modal modal={modalInfo} updateModal={setModalInfo} >
                    <ObjectDinamicViewer data={bean} head={head} columns={1} />
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal
                    modal={modal}
                    updateModal={setModal}
                    eventModal={startProcess}
                    onSubmitLabel="Solicitar"
                >
                    <div className="row">
                        <InfoRow label="Valor Mínimo:" value={_single.formatFieldMask(bean.MinimumLoanAmount, MASK_MONEY)} />
                        <InfoRow label="Valor Máximo:" value={_single.formatFieldMask(bean.MaximumLoanAmount, MASK_MONEY)} />
                        <InfoRow label="Porcentaje de Interés:" value={`${parseFloat(bean.CurrentPercentInterest)}%`} />
                        <InfoRow label="Porcentaje de Interés Vencido:" value={`${parseFloat(bean.ExpiredPercentInterest)}%`} />
                        <InfoRow label="Mínimo tiempo de servicio:" value={bean.MinimumServiceTime} />
                        {bean.RequiresCodebtor && (
                            <InfoRow
                                label="Requiere Codeudor:"
                                value={_single.formatFieldMask(bean.RequiresCodebtor, MASK_BOOLEAN)}
                            />
                        )}
                    </div>
                </Modal>
            </div>
        </div>
    );
};

const InfoRow = ({ label, value }) => (
    <div className="col-md-12 d-flex justify-content-between">
        <strong>{label}</strong>
        <small dangerouslySetInnerHTML={{ __html: value }} />
    </div>
);
